import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component, InfoList } from './types';

export const NewCarInfoList: Component = ({
  children,
}) => {
  const { isDesktop } = useScreenDetect();
  const isScreenDesktop = isDesktop();
  const infoList: InfoList = children.map((
    item,
    index,
  ) => ({
    key: `info-item-${index}`,
    item,
  }));
  const twoColumnList: { columnKey: string; columns: InfoList; }[] = [];

  for (let i = 0; i < infoList.length; i += 2) {
    const column = infoList.slice(i, i + 2);

    twoColumnList.push({ columnKey: `group-${(i / 2) + 1}`, columns: column });
  }

  const isDouble = infoList.length === 2;
  const isTwoColumn = (infoList.length > 2) && (infoList.length % 2) === 0;
  const isTriple = infoList.length === 3;

  return (
    <div className={cx(
      styles.containerRoot,
      isTwoColumn && styles.isTwoColumn,
    )}>
      {(isTwoColumn && isScreenDesktop) && twoColumnList.map(({
        columns,
        columnKey,
      }) => (
        <div
          key={columnKey}
          className={styles.halfColumnContainer}>
          {columns.map(({ item, key }) => (
            <div
              key={key}>
              {item}
            </div>
          ))}
        </div>
      ))}
      <div className={cx(
        styles.containerContent,
        isDouble && styles.isDouble,
        isTriple && styles.isTriple,
      )}>
        {(!isTwoColumn || !isScreenDesktop) && infoList.map(({
          key,
          item,
        }) => (
          <div
            key={key}
            className={styles.containerNewItem}>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};
